import { useRef, useState } from "react";
import { getDetails } from "../services/truckAssets";

function useTruckCheck() {
  const [isTruckFound, setIsTruckFound] = useState(false);
  const [foundTruck, setFoundTruck] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const truckChecks = useRef([]);

  async function checkForTruck(stockNumber) {
    if (!stockNumber) {
      return;
    }

    setIsLoading(true);

    const existingCheck = truckChecks.current.find(
      (check) => check.stockNumber === stockNumber
    );

    if (existingCheck) {
      setIsTruckFound(existingCheck.isActive);
      setFoundTruck(existingCheck.stockNumber);
      setIsLoading(false);

      return;
    }

    try {
      let returnObj = {};

      const truckCheck = await getDetails(stockNumber);

      if (truckCheck.status === 404) {
        returnObj = { stockNumber, isActive: false };

        setFoundTruck(stockNumber);
        setIsTruckFound(false);
      } else if (truckCheck.status === 409) {
        returnObj = { stockNumber, isActive: false, isMultiple: true };

        setFoundTruck(stockNumber);
        setIsTruckFound(false);
      } else {
        returnObj = { stockNumber, isActive: true };

        setFoundTruck(stockNumber);
        setIsTruckFound(true);
      }

      truckChecks.current = [...truckChecks.current, returnObj];

      return returnObj;
    } catch (err) {
      console.error("There was an error searching for an existing truck", err);

      setFoundTruck(null);
      setIsTruckFound(false);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    isTruckFound,
    foundTruck,
    isLoading,
    checkForTruck,
  };
}

export { useTruckCheck };
